export default [{
  path: '/envio-automatico',
  name: 'envio-automatico',
  component: () => import('@/app/envio-automatico/EnvioAutomaticoView.vue'),
  meta: {
    resource: 'envio_automatico',
    action: 'create',
    pageTitle: 'Envio Automático',
    breadcrumb: [],
  },
}]
